import React from "react";

import "./styles.css";

export default function InsuranceAIProcessing() {
  return (
    <div className="insurance-ai-processing">
      <div className="insurance-text-container">
        <p className="insurance-ai-processing-text">AI is still analyzing this submission.</p>
        <p className="insurance-ai-processing-text">Analytics will be ready soon.</p>
      </div>
    </div>
  );
}
